export default __webpack_public_path__ + "static/media/736.598a0291.png";